import type { ESchoolType } from '@/shared/types';

import { PublishedDropdown } from './components/PublishedDropdown/PublishedDropdown';
import { UnpublishedDropdown } from './components/UnpublishedDropdown/UnpublishedDropdown';

interface IProp {
  isSchoolActive: boolean;
  id: number;
  openUnpublishModalCb: VoidFunction;
  schoolType: ESchoolType;
}

export const OptionsCell = ({ isSchoolActive, id, openUnpublishModalCb, schoolType }: IProp) => {
  switch (isSchoolActive) {
    case true: {
      return (
        <PublishedDropdown
          id={id}
          openUnpublishModalCb={openUnpublishModalCb}
          schoolType={schoolType}
        />
      );
    }
    case false: {
      return (
        <UnpublishedDropdown
          id={id}
          schoolType={schoolType}
        />
      );
    }
  }
};
